import { setUserId, trackStructEvent } from '@snowplow/browser-tracker';

import { TRACKER_NAME, initialiseSnowplowTracker } from '~/services/snowplow/initialiseTracker';

/** Usage intent only; successful report loads must be recorded by their data boundary. */
export function trackMigrationEvent(action: string, email?: string | null, label?: string, property?: string): void {
  try {
    if (!initialiseSnowplowTracker()) return;
    if (email) setUserId(email, [TRACKER_NAME]);
    trackStructEvent({ category: 'askrichard_migration', action, label, property }, [TRACKER_NAME]);
  } catch {
    // Analytics must never interrupt report navigation.
  }
}
